import { matchesDomainOrTestAlias } from "./domain";

export type RendaTemplate = "renda" | "twentyFiveSeven";

export function detectTemplate(): RendaTemplate {
  const host = window.location.hostname.toLowerCase();
  const twentyFiveSevenDomain = getEnvString("VITE_RENDA_25NA7_DOMAIN");

  if (
    twentyFiveSevenDomain &&
    matchesDomainOrTestAlias(host, twentyFiveSevenDomain)
  ) {
    return "twentyFiveSeven";
  }

  return "renda";
}

const THEMES: Record<RendaTemplate, () => Promise<unknown>> = {
  renda: () => import("../default-colors.scss"),
  twentyFiveSeven: () => import("../twenty-five-seven-colors.scss"),
};

export async function loadTheme(): Promise<void> {
  await THEMES[detectTemplate()]();
}

function getEnvString(name: string): string {
  const value = import.meta.env[name];

  return typeof value === "string" ? value.toLowerCase() : "";
}
